export default {"src":"/_next/static/media/soem-labs-logo.7a8b5f16.svg","height":97,"width":561};